/**
 * Suggested prompts for the V2 welcome screen.
 *
 * Source: https://www.notion.so/Things-Companion-Should-Do-34985d7fd0d280918528e99c12339b0a
 *
 * Each bullet on that page is a capability; the strings below are user-phrased
 * versions of those capabilities, kept short enough to read on a button.
 */
export const SUGGESTED_PROMPTS = [
  // Notes — edit, generate, find, query
  "Edit this note to reformat into bullet points",
  "Generate a summary for my last visit",
  "Draft discharge instructions for today's patient",
  "Write a friendly client email about this visit",
  "Draft a referral letter from this note",
  "Summarize my notes from this week",

  // Templates
  "Create a template for canine wellness exams",
  "Optimize my SOAP template",
  "Create a template for an RVT interview",

  // Practice insights
  "How many notes have I created this week?",
  "Give me a summary of my week",
  "What treatments were declined this week?",

  // General / Scribenote how-to
  "Take me to my templates",

  // Clinical / research
  "Calculate trazodone dosage for a 30kg dog",
  "Safety precautions around a rabid animal?",
  "Check drug interactions between furosemide and enalapril",
  "Latest research on feline diabetes",
];

/**
 * Pick `count` unique random prompts. Used to freshen the welcome screen
 * on each mount without over-engineering a server-side rotation.
 */
export function pickRandomPrompts(count: number): string[] {
  return [...SUGGESTED_PROMPTS]
    .sort(() => Math.random() - 0.5)
    .slice(0, count);
}
